export default __webpack_public_path__ + "static/media/img4.3fa49973.jpg";